import useAuthContext from '@salesforce/commerce-sdk-react/hooks/useAuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { useBasket } from '../baskets/useBasket';
import { bffPost } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { CustomerAddress, CustomerProductList } from './model';

export const useMoveAllSaveForLaterToBasket = (): UseMutationResult<
    CustomerProductList,
    unknown,
    unknown
> => {
    const auth = useAuthContext();
    const queryClient = useQueryClient();
    const { data } = useBasket();

    return useMutation<CustomerProductList, unknown, unknown>({
        mutationFn: async () => {
            const { customer_id, access_token } = await auth.ready();

            return bffPost<CustomerAddress>(
                `/customers/${customer_id}/save-for-later/add-all-products-to-basket/${data?.basketId}`,
                {
                    basketCustomerId: data?.customerInfo?.customerId,
                    accessToken: access_token,
                    customerId: customer_id,
                },
            );
        },
        onSuccess: async (payload: CustomerProductList): Promise<void> => {
            queryClient.setQueryData([BffQueryKey.CUSTOMER_SAVE_FOR_LATER], payload);

            await Promise.all([
                queryClient.invalidateQueries([BffQueryKey.BASKET], {
                    exact: false,
                }),
                queryClient.invalidateQueries([BffQueryKey.BASKET_INVENTORY], {
                    exact: false,
                }),
                queryClient.invalidateQueries([BffQueryKey.BASKET_AVAILABILITY], {
                    exact: false,
                }),
            ]);
        },
    });
};
